import restBase from './restBase';
import systemApi from './systemApi';
import productApi from './productApi';
import agentApi from './agentApi';
import logApi from './logApi';
import eventApi from './eventApi';
import dashboardApi from './dashboardApi';
import authApi from './authApi';

export let restManager = Object.assign(
  restBase,
  systemApi,
  productApi,
  logApi,
  agentApi,
  eventApi,
  authApi,
  dashboardApi
);

export default {
  // const app = createApp({})
  install(app) {
    //다른 컴포넌트나 main.js에서 Vue.use(ChartPlugin) 을 명시할 경우 ChartPlugin.install(Vue)이 실행된다.
    app.config.globalProperties.$http = restManager;
    // createApp.prototype.$http = restManager;
  }
};
